/**
 * Normalize userType to handle different naming conventions (userType, usertype, user_type)
 * @param userData - User data object that may contain userType in different formats
 * @returns The userType object or undefined if not found
 */
export const getUserType = (userData: any) => {
  if (!userData) return undefined;
  return userData.userType || userData.usertype || userData.user_type;
};

